'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import PreviewIframe from 'ContentComponents/components/preview/PreviewIframe';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { DeviceFrameDesktop } from 'foundations-components/transitional/components/DeviceFrame';
import { DeviceFrameMobile } from 'foundations-components/transitional/components/DeviceFrame';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PreviewDevices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileLoaded: false,
      desktopLoaded: false
    };
    this.onLoad = this.onLoad.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.renderPreviewComponent = this.renderPreviewComponent.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      customPreview,
      previewUrl,
      previewHTMLOutput,
      shouldUseHTMLPreview
    } = this.props;
    const isPreviewUrlDifferent = prevProps.previewUrl !== previewUrl;
    const switchedToIframePreview = !customPreview && prevProps.customPreview;
    const showPreviewHTMLOutputLoading = !previewHTMLOutput && shouldUseHTMLPreview;
    if (!customPreview && isPreviewUrlDifferent && showPreviewHTMLOutputLoading || switchedToIframePreview) {
      this.setState({
        mobileLoaded: false,
        desktopLoaded: false
      });
    }
  }
  onLoad(type) {
    return () => {
      this.setState({
        [`${type}Loaded`]: true
      });
    };
  }
  renderLoading() {
    if (this.props.isLoading || !this.props.customPreview && !(this.state.mobileLoaded && this.state.desktopLoaded)) {
      return /*#__PURE__*/_jsx(LoadingOverlay, {
        contextual: true
      });
    }
    return null;
  }
  renderPreviewComponent(type) {
    const {
      from,
      previewSubject,
      subject,
      previewUrl,
      previewHTMLOutput,
      shouldUseHTMLPreview,
      selectedContact,
      contentType,
      customPreview,
      uniqueFrameId,
      inpage
    } = this.props;
    const renderedSubject = previewSubject || subject;
    return /*#__PURE__*/_jsx(PreviewIframe, {
      to: selectedContact,
      from: from,
      subject: renderedSubject,
      previewUrl: previewUrl,
      previewHTMLOutput: previewHTMLOutput,
      shouldUseHTMLPreview: shouldUseHTMLPreview,
      contentType: contentType,
      type: type,
      onLoad: this.onLoad(type),
      uniqueFrameId: uniqueFrameId,
      customPreview: customPreview,
      inpage: inpage
    });
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      id: "preview-devices",
      "data-selenium": "preview-devices",
      children: /*#__PURE__*/_jsx(View, {
        height: "100%",
        overflowY: "scroll",
        padding: "500",
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsxs(Flex, {
          justifyContent: "center",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "700",
          flexBasis: "100%",
          children: [/*#__PURE__*/_jsxs(DeviceFrameDesktop, {
            "data-test-id": "desktop-device-frame",
            blockSize: "723px",
            inlineSize: "840px",
            children: [this.renderLoading(), this.renderPreviewComponent('desktop')]
          }), /*#__PURE__*/_jsxs(DeviceFrameMobile, {
            "data-test-id": "mobile-device-frame",
            inlineSize: "369px",
            children: [this.renderLoading(), this.renderPreviewComponent('mobile')]
          })]
        })
      })
    });
  }
}
PreviewDevices.defaultProps = {
  from: null,
  subject: '',
  selectedContact: null,
  isLoading: false,
  customPreview: null
};
PreviewDevices.propTypes = {
  previewUrl: PropTypes.string.isRequired,
  previewHTMLOutput: PropTypes.string,
  selectedContact: PropTypes.shape({
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  from: PropTypes.shape({
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  subject: PropTypes.string,
  uniqueFrameId: PropTypes.string,
  shouldUseHTMLPreview: PropTypes.bool,
  previewSubject: PropTypes.string,
  isLoading: PropTypes.bool,
  contentType: PropTypes.string.isRequired,
  inpage: PropTypes.bool,
  customPreview: PropTypes.object
};
export default PreviewDevices;